const API_BASE = import.meta.env.VITE_API_BASE ?? ''

/**
 * Build the URL for viewing/downloading a document. The optional
 * `/{filename}` segment controls the Content-Disposition name the
 * browser uses for "Save as…" dialogs.
 */
export function documentUrl(id: number, filename?: string | null): string {
  if (!filename) return `${API_BASE}/api/documents/${id}`
  return `${API_BASE}/api/documents/${id}/${encodeURIComponent(filename)}`
}
